"use strict";
// @ts-nocheck
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
exports.__esModule = true;
var React = __importStar(require("react"));
;
function xmr(_a) {
    var size = _a.size, _b = _a.color, color = _b === void 0 ? "currentColor" : _b;
    return React.createElement("svg", { width: size, height: size, viewBox: "0 0 24 24", fill: "none" },
        React.createElement("path", { d: "M11.9992 3.89325C16.488 3.89325 20.118 7.52325 20.118 12.0112C20.1149 12.8859 19.9737 13.7547 19.6995 14.5852H17.28V7.76475L12 13.0447L6.71996 7.76475V14.5852H4.29971C4.02574 13.7546 3.88476 12.8859 3.88196 12.0112C3.88196 7.52325 7.51196 3.89325 12 3.89325H11.9992ZM10.7902 14.232L12.0217 15.4432L13.2315 14.2327L15.5197 11.9227V16.2127H18.93C18.2066 17.4024 17.189 18.3857 15.9752 19.0677C14.7613 19.7498 13.3923 20.1076 12 20.1068C9.07346 20.1068 6.49946 18.5452 5.06996 16.2127H8.47946V11.9227L10.7895 14.2327L10.7902 14.232Z", fill: color }));
}
exports["default"] = xmr;
//# sourceMappingURL=xmr.js.map